var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import TextArea from "@irati/ui/src/FormItem/TextArea";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import { Body, H1 } from "@irati/ui/src/Typography";
import Spacing from "@irati/ui/src/Spacing";
var EditWelcomeEmailContent = /** @class */ (function (_super) {
    __extends(EditWelcomeEmailContent, _super);
    function EditWelcomeEmailContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditWelcomeEmailContent.prototype.render = function () {
        var _a = this.props, welcomeEmail = _a.welcomeEmail, welcomeEmailMaxLength = _a.welcomeEmailMaxLength, handleWelcomeEmailChange = _a.handleWelcomeEmailChange, useDefault = _a.useDefault, saveWelcomeEmail = _a.saveWelcomeEmail;
        var charactersOverTheLimit = welcomeEmail.length - welcomeEmailMaxLength;
        return (React.createElement(Flex, { direction: "column", width: "75%" },
            React.createElement(H1, { marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "admin.components.welcomeEmail.headerTwo.text" })),
            React.createElement(Body, null,
                React.createElement(FormattedMessage, { id: "admin.components.welcomeEmail.headerFour.text" })),
            React.createElement(Row, null,
                React.createElement(Spacing, { marginTop: 2 },
                    React.createElement(TextArea, { hideLabel: true, onChange: handleWelcomeEmailChange, maxLength: welcomeEmailMaxLength, value: welcomeEmail, rows: 6 }))),
            welcomeEmail.length >= welcomeEmailMaxLength && (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "admin.components.welcomeEmail.charactersOverTheLimit", values: { count: charactersOverTheLimit } }))),
            React.createElement(Flex, { marginTop: 2 },
                React.createElement(Button, { marginRight: true, onClick: useDefault },
                    React.createElement(FormattedMessage, { id: "admin.components.welcomeEmail.styledButton.useDefault" })),
                React.createElement(Button, { primary: true, onClick: saveWelcomeEmail },
                    React.createElement(FormattedMessage, { id: "admin.components.welcomeEmail.styledButton.save" })))));
    };
    return EditWelcomeEmailContent;
}(Component));
export default EditWelcomeEmailContent;
